import { useRef } from 'react';

import isSameAction from './actionEquality';
import type { MapAction } from './types';

const useUndo = () => {
    const undoStackRef = useRef<MapAction[]>([]);
    const redoStackRef = useRef<MapAction[]>([]);

    const addAction = (action: MapAction) => {
        if (undoStackRef.current.length > 0) {
            const lastAction = undoStackRef.current[undoStackRef.current.length - 1];

            if (isSameAction(lastAction, action)) {
                return;
            }
        }

        undoStackRef.current = [...undoStackRef.current, action];
        redoStackRef.current = [];
    };

    const clearActions = () => {
        undoStackRef.current = [];
        redoStackRef.current = [];
    };

    const undo = () => {
        if (undoStackRef.current.length === 0) {
            return;
        }

        if (undoStackRef.current.length === 1) {
            // we are loading the initial state
            return undoStackRef.current[0];
        }
        const lastAction = undoStackRef.current.pop() as MapAction;

        redoStackRef.current = [...redoStackRef.current, lastAction];

        if (undoStackRef.current.length >= 1) {
            return undoStackRef.current[undoStackRef.current.length - 1];
        }

        return;
    };

    const redo = () => {
        if (redoStackRef.current.length === 0) {
            return;
        }

        const action = redoStackRef.current[redoStackRef.current.length - 1];

        redoStackRef.current = redoStackRef.current.slice(0, -1);
        undoStackRef.current = [...undoStackRef.current, action];

        return action;
    };

    return {
        addAction,
        clearActions,
        redo,
        undo
    };
};

export default useUndo;
